import { useEffect, useState } from "react";
import axios from "axios";
import { fetchBranding } from "../services/branding";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    // ✅ Never throw on HTTP error status — we handle all responses manually
    validateStatus: () => true,
});

const styles = {

    page:{
        height:"100vh",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        background:"#f4f6f8"
    },

    card:{
        background:"#fff",
        padding:"40px",
        borderRadius:"8px",
        width:"320px",
        boxShadow:"0 2px 10px rgba(0,0,0,0.1)",
        display:"flex",
        flexDirection:"column",
        gap:"15px"
    },

    input:{
        padding:"10px",
        border:"1px solid #ccc",
        borderRadius:"4px"
    },

    inputError:{
        padding:"10px",
        border:"1px solid #e53935",
        borderRadius:"4px",
        background:"#fff8f8"
    },

    button:{
        padding:"10px",
        background:"#1976d2",
        color:"#fff",
        border:"none",
        cursor:"pointer",
        borderRadius:"4px"
    },

    buttonLoading:{
        padding:"10px",
        background:"#90bce8",
        color:"#fff",
        border:"none",
        cursor:"not-allowed",
        borderRadius:"4px"
    },

    errorBox:{
        background:"#fdecea",
        border:"1px solid #f5c6cb",
        color:"#c62828",
        padding:"10px 12px",
        borderRadius:"4px",
        fontSize:"13px",
        textAlign:"center"
    }

};

function Login(){

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [branding, setBranding] = useState({});
    const [error,    setError]    = useState("");
    const [loading,  setLoading]  = useState(false);

    const login = async () => {
        setError("");
        setLoading(true);

        try {
            const res = await API.post("/auth/login", { username, password });

            // ✅ With validateStatus: () => true, Axios NEVER throws.
            // We check the status ourselves here.
            if (res.status === 200) {
                localStorage.setItem("token", res.data.token);
                window.location = "/";
            } else {
                // Grab the message from whatever shape the server sends
                const msg =
                    res.data?.message ||
                    res.data?.error   ||
                    (typeof res.data === "string" ? res.data : null) ||
                    `Login failed (${res.status}).`;
                setError(msg);
            }

        } catch (err) {
            // Only real network errors (no internet, DNS fail) reach here now
            setError("Cannot reach the server. Please check your connection.");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") login();
    };

    useEffect(() => {
        fetchBranding().then(setBranding);
    }, []);

    return(

        <div style={styles.page}>
            <div style={styles.card}>
                {branding.logoUrl && (
                    <img
                        src={branding.logoUrl}
                        alt="Store logo"
                        style={{ maxHeight: "48px", objectFit: "contain", margin: "0 auto 10px" }}
                    />
                )}
                <h2 style={{ textAlign: "center" }}>
                    {branding.storeName || "Katz's Logger Dashboard"}
                </h2>

                {error && <div style={styles.errorBox}>{error}</div>}

                <input
                    style={error ? styles.inputError : styles.input}
                    placeholder="Username"
                    value={username}
                    onChange={e => { setUsername(e.target.value); setError(""); }}
                    onKeyDown={handleKeyDown}
                />

                <input
                    style={error ? styles.inputError : styles.input}
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => { setPassword(e.target.value); setError(""); }}
                    onKeyDown={handleKeyDown}
                />

                <button
                    style={loading ? styles.buttonLoading : styles.button}
                    onClick={login}
                    disabled={loading}
                >
                    {loading ? "Logging in…" : "Login"}
                </button>
            </div>
        </div>

    );

}

export default Login;